import { DATA_ATTRIBUTE_FOR_USER_INFO, LEGAL_USER_TYPE } from '@app/configs/configProvider';
import UserConfig from './UserConfig';
class ConfigProvider {
    constructor(element = document.documentElement) {
        const userSettings = element.getAttribute(DATA_ATTRIBUTE_FOR_USER_INFO) || '{}';
        this.userConfig = JSON.parse(userSettings);
    }
    getUserConfig() {
        return new UserConfig(this.userConfig.user_id, this.userConfig.administer_user_id, this.userConfig.administered_user_identifier, this.userConfig.time_zone, this.userConfig.time_format, this.userConfig.date_format, this.userConfig.user_identifier, this.userConfig.user_type, this.userConfig.administered_user_type, this.userConfig.impersonator_user_id, this.userConfig.preferred_currency, this.userConfig.user_level, this.userConfig.identity_country);
    }
    isLegalUserType() {
        return this.userConfig.administered_user_type === LEGAL_USER_TYPE;
    }
    getAdministeredUserId() {
        return this.userConfig.administer_user_id;
    }
}
export default new ConfigProvider();
